// extracted by mini-css-extract-plugin
module.exports = {"description":"MediaDescription_description__71Xim"};